import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import React from 'react'

interface CuppingCheckboxProps {
  value: number
  label: string
  options: Array<{ id: number; value: number; label: string }>
  onChange: (newValue: number) => void
}

const CuppingCheckbox = (props: CuppingCheckboxProps): JSX.Element => {
  return (
    <FormControlLabel
      sx={{ mb: 3 }}
      control={
        <Switch
          checked={props.options[1].value === props.value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            props.onChange(event.target.checked ? props.options[1].value : props.options[0].value)
          }
        />
      }
      label={props.label}
    />
  )
}

export default CuppingCheckbox
